import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=7d7156f1&scoped=true&lang=pug&"
var script = {}
import style0 from "./Navigation.vue?vue&type=style&index=0&id=7d7156f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7156f1",
  null
  
)

export default component.exports